import { useState, useEffect } from "react";
import { Box, Button, SxProps, Theme } from "@mui/material";

export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToRequirements = () => {
    const element = document.getElementById("requirements-section");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box
      sx={{
        ...containerSx,
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? "auto" : "none",
      }}
    >
      <Button sx={buttonSx} onClick={scrollToRequirements}>
        エントリーする
      </Button>
    </Box>
  );
};

const containerSx: SxProps<Theme> = {
  position: "fixed",
  bottom: { md: "32px", xs: "20px" },
  right: { md: "32px", xs: "16px" },
  zIndex: 1000,
  transition: "opacity 0.3s ease",
};

const buttonSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #22A1B9, #00BFA5)",
  color: "#FFFFFF",
  fontWeight: 700,
  padding: { md: "14px 28px", xs: "12px 20px" },
  fontSize: { md: "15px", xs: "14px" },
  borderRadius: "30px",
  textTransform: "none",
  boxShadow: "0 4px 20px rgba(0, 191, 165, 0.4)",
  transition: "all 0.3s",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 30px rgba(0, 191, 165, 0.5)",
  },
};
